import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const test = [
  {
    name: "rent your paris",
    email: "rentyourparis.com",
    users: 2,
    createdAt: "12 janvier"
  },
  {
    name: "bnp paribas",
    email: "bnpparibas.com",
    users: 3,
    createdAt: "12 janvier"
  }
];

const styles = theme => ({
  title: {
    marginBottom: 15
  },
  inputForm: {
    marginTop: 15,
    marginBottom: 15,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  inputLabel: {
    marginRight: 10,
    marginLeft: 10
  },

  table: {
    minWidth: 700
  },
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  button: {
    marginLeft: 15
  }
});

class Client extends PureComponent {
  state = {
    name: "",
    owner: "",
    domain: ""
  };

  componentDidMount = () => {
    this.props.getClientListRequest();
  };

  onChangeClient = event => {
    this.props.changeCreateField({ name: event.target.value });
  };

  onChangeEmail = event => {
    this.props.changeCreateField({ owner: event.target.value });
  };

  onChangeDomain = event => {
    this.props.changeCreateField({ domain: event.target.value });
  };

  onSubmit = () => {
    this.props.createClientRequest({
      name: this.props.name,
      owner: this.props.owner,
      domain: this.props.domain
    });
  };

  renderClientList = clients => {
    return clients.map((client, i) => {
      return (
        <TableRow key={i}>
          <TableCell component="th" scope="row">
            {client.name}
          </TableCell>
          <TableCell>{client.domain}</TableCell>
          <TableCell>{client.employees}</TableCell>
          <TableCell>{client.owner}</TableCell>
          <TableCell>{client.isExecutive ? "true" : "false"}</TableCell>
          <TableCell>{client.createdAt}</TableCell>
          {/* <TableCell numeric>{client.carbs}</TableCell> */}
          {/* <TableCell numeric>{client.protein}</TableCell> */}
        </TableRow>
      );
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Typography className={classes.title} variant="h3">
          Clients
        </Typography>
        <Typography variant="h4">Entrer un nouveau client :</Typography>
        <div className={classes.inputForm}>
          <InputLabel className={classes.inputLabel}>
            Nom du client :
          </InputLabel>
          <Input
            id="client"
            name="client"
            autoFocus
            placeholder="Rent your Paris"
            value={this.props.name}
            onChange={this.onChangeClient}
          />

          <InputLabel className={classes.inputLabel}>
            Nom de DOMAINE :
          </InputLabel>
          <Input
            id="client"
            name="client"
            autoFocus
            placeholder="rentyourparis.com"
            value={this.props.domain}
            onChange={this.onChangeDomain}
          />

          <InputLabel className={classes.inputLabel}>
            Adress mail du recap :
          </InputLabel>
          <Input
            id="email"
            name="email"
            type="email"
            autoFocus
            placeholder="ap@pulse-experience.co"
            value={this.props.owner}
            onChange={this.onChangeEmail}
          />
          <Button
            disabled={
              !this.props.owner || !this.props.domain || !this.props.name
            }
            variant="contained"
            onClick={this.onSubmit}
            color="primary"
            className={classes.button}
          >
            Créer
          </Button>
        </div>
        <Typography variant="h4">Liste des clients :</Typography>
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Domain</TableCell>
                <TableCell>Utilisateurs</TableCell>
                <TableCell>Mail Recap</TableCell>
                <TableCell>isExecutive</TableCell>
                <TableCell>Date</TableCell>
                {/* <TableCell numeric>Carbs (g)</TableCell> */}
                {/* <TableCell numeric>Protein (g)</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>{this.renderClientList(this.props.clients)}</TableBody>
          </Table>
        </Paper>
        {/* <List>{this.renderList(this.props.clients.list)}</List> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { owner, name, domain } = state.client;
  return {
    token: state.auth.token,
    owner,
    name,
    domain,
    clients: state.client.list
  };
};

export default connect(
  mapStateToProps,
  {}
)(withStyles(styles)(Client));
